import * as ActionTypes from '../ActionTypes';

export const GetWorkSpaceDojAction = (params) => {
    return {
        type: ActionTypes.GET_WORKSPACEDOJ_REQUEST,
        params
    }
}